import Api from '../../../services';

export const getPayments = (params) => {
  return (dispatch) => {
    return Api.guestApi.payments.getPayments(params).then((response) => {
      dispatch({
        type: 'GET_PAYMENTS',
        data: response,
      });
      return response;
    });
  };
};

export const getPaymentDetails = (paymentId) => {
  return (dispatch) => {
    return Api.guestApi.payments.getPaymentDetails(paymentId).then((response) => {
      dispatch({
        type: 'GET_PAYMENT_DETAILS',
        data: response,
      });
      return response;
    });
  };
};
